import { Link, router, Slot, useGlobalSearchParams } from "expo-router";
import { Chips } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { View, XStack } from "tamagui";

import { api } from "~/utils/api";
import { ResearchBreadcrumbs } from "~/components/feature/research";
import { usePathIncludes } from "~/hooks";

const Layout = () => {
  const { type, researchId } = useGlobalSearchParams<{
    type: string;
    researchId: string;
  }>();

  const { t } = useTranslation("research");

  const [slice] = api.research.types.useSuspenseQuery(undefined, {
    select: (data) => data.find((item) => item.value === type),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const [researchName] = api.research.getResearchNameById.useSuspenseQuery({
    researchId,
  });

  const { match } = usePathIncludes();
  const navItems = t("participants-page.breadcrumbs", {
    returnObjects: true,
  });

  return (
    <>
      <View gap={"$2"}>
        <ResearchBreadcrumbs
          list={[
            slice,
            {
              name: researchName,
              value: researchId,
            },
          ]}
          active={researchId}
          onPress={(value) => {
            if (value === type) {
              router.push(`/research/${value}`);
            }
          }}
        />

        <XStack gap={"$1"}>
          {navItems.map(({ value, name }) => (
            <Link key={value} href={`/research/${type}/${researchId}/${value}`}>
              <Chips.Chip
                cursor="pointer"
                selected={match(value)}
                backgroundColor="#0B564C"
              >
                {name}
              </Chips.Chip>
            </Link>
          ))}
        </XStack>
      </View>
      <Slot />
    </>
  );
};

export default Layout;
